import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  skeleton: {
    borderRadius: "8px",
    height: "65px",
    width: "100%",
  },
}));

export default useStyles;
